<template>
  <router-link to="/" class="tivo-logo">
    <div class="tivo-logo-icon">
      <svg viewBox="0 0 32 32" width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 4L28 10V22L16 28L4 22V10L16 4Z" fill="url(#tivo-grad1)"/>
        <path d="M16 8L24 12V20L16 24L8 20V12L16 8Z" fill="url(#tivo-grad2)"/>
        <defs>
          <linearGradient id="tivo-grad1" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
            <stop stop-color="#F5C842"/>
            <stop offset="1" stop-color="#7C5CBF"/>
          </linearGradient>
          <linearGradient id="tivo-grad2" x1="8" y1="8" x2="24" y2="24" gradientUnits="userSpaceOnUse">
            <stop stop-color="#5B9CF5"/>
            <stop offset="1" stop-color="#7C5CBF"/>
          </linearGradient>
        </defs>
      </svg>
    </div>
    <span class="tivo-logo-text">Tivo</span>
  </router-link>
</template>
<style scoped>
.tivo-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  flex: 1;
  min-width: 0;
}
.tivo-logo-icon {
  flex-shrink: 0;
}
.tivo-logo-text {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.5px;
}
</style>